import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEwsreportsFromAPI, fetchEwsreportsFromAPI, downloadStockFileFromAPI, downloadEwsStockReportPdfFromAPI } from "../../../services/EwsreportService";


export const fetchEwsreports = createAsyncThunk(
  "ewsreports/fetchEwsreports",
  async ({ page, perPage, search, columnFilters }, { rejectWithValue, signal }) => {
    try {
      const response = await fetchEwsreportsFromAPI(page, perPage, search, columnFilters, signal);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteEwsreport = createAsyncThunk(
  "ewsreports/deleteEwsreport",
  async (ewsreportId, { rejectWithValue }) => {
    try {
      const response = await deleteEwsreportsFromAPI(ewsreportId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);



// Download Forecast File
export const downloadStockFile = createAsyncThunk(
  "ewsreports/downloadStockFile",
  async ({ fileType, search }, { rejectWithValue }) => {
    try {
      const response = await downloadStockFileFromAPI(fileType, search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download forecast file.");
    }
  }
);

// Download EWS Stock Report PDF
export const downloadEwsStockReportPdf = createAsyncThunk(
  "ewsreports/downloadEwsStockReportPdf",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await downloadEwsStockReportPdfFromAPI(search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download EWS stock report PDF.");
    }
  }
);


const ewsreportSlice = createSlice({
  name: "ewsreports",
  initialState: {
    ewsreports: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    ewsreportSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:{
      vendor_code:'ALL'
    },
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchEwsreport: (state, action) => {
      state.ewsreportSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEwsreports.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEwsreports.fulfilled, (state, action) => {
        const ewsreports = action.payload;
        state.loading = false;
        state.ewsreports = ewsreports.data;
        state.currentPage = ewsreports.current_page;
        state.lastPage = ewsreports.last_page;
        state.perPage = ewsreports.per_page;
        state.firstItem = ewsreports.from; // ✅ Ambil `from` dari API
        state.totalCount = ewsreports.total;
      })
      .addCase(fetchEwsreports.rejected, (state, action) => {
        if (action.meta?.aborted) return; // superseded by a newer fetch — ignore
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEwsreport.fulfilled, (state, action) => {
        state.ewsreports = state.ewsreports.filter(ewsreport => ewsreport.id !== action.payload);
      })
      .addCase(deleteEwsreport.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchEwsreport, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters } = ewsreportSlice.actions;
export default ewsreportSlice.reducer;



